import {createTheme} from '@mui/material/styles'

const theme = createTheme({
    palette: {
        mode: 'dark',
    },
    typography: {
        fontFamily: `"Roboto", "Helvetica", "Arial", sans-serif`,
        fontSize: 14,
        fontWeightLight: 300,
        fontWeightRegular: 400,
        fontWeightMedium: 500,
        h1: {
            fontFamily: `"Nunito", "Helvetica", "Arial", sans-serif`,
        },
        h2: {
            fontFamily: `"Nunito", "Helvetica", "Arial", sans-serif`,
        },
        h3: {
            fontFamily: `"Nunito", "Helvetica", "Arial", sans-serif`,
        },
        h4: {
            fontFamily: `"Nunito", "Helvetica", "Arial", sans-serif`,
        },
        h5: {
            fontFamily: `"Nunito", "Helvetica", "Arial", sans-serif`,
        },
    },
    components: {
        MuiButton: {
            variants: [
                {
                    props: {variant: 'contained-1'},
                    style: {
                        fontFamily: `"Nunito", "Helvetica", "Arial", sans-serif`,
                        padding: '10px 50px',
                        minWidth: '140px',
                        background: '#490ec0',
                        color: '#fff',
                        borderRadius: '20px',
                        fontWeight: 'bold',
                    },
                },
                {
                    props: {variant: 'contained-2'},
                    style: {
                        fontFamily: `"Nunito", "Helvetica", "Arial", sans-serif`,
                        padding: '10px 50px',
                        minWidth: '140px',
                        background: '#f9188d',
                        color: '#fff',
                        borderRadius: '20px',
                        fontWeight: 'bold',
                    },
                },
            ],
        },
    },
})

export default theme
